// ===== Enums =====

export enum CustomFieldDataType {
  Text = 'Text',
  Number = 'Number',
  Date = 'Date',
  DateTime = 'DateTime',
  Boolean = 'Boolean',
}

// ===== View Models =====

export interface CustomFieldViewModel {
  tenantId: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string | null;
  updatedBy: string | null;
  customFieldId: number;
  name: string | null;
  dataType: CustomFieldDataType;
}

// ===== Request Models =====

export interface CreateOrUpdateCustomFieldViewModel {
  name: string;
  dataType: CustomFieldDataType;
}

